import Component from '../colorz/Component';
import Device from '@utils/html/Device';
import {breakpointsApp} from '../colorz/configClrzApp';

export default class TabIndexMobile extends Component {
	onInit(el) {
		this.el = el;
	}

	onReady() {
		this.isMobile = Device.width < breakpointsApp.desktop;

		if (this.isMobile) {
			// Check if the menu panel should be hidden BEFORE removing attributes
			let shouldMakeNonTabbable = false;
			if (
				this.el.id === 'menu-mobile' ||
				this.el.classList.contains('js-nav-panel')
			) {
				shouldMakeNonTabbable =
					this.el.hasAttribute('hidden') ||
					this.el.getAttribute('aria-hidden') === 'true';
			}

			this.el.removeAttribute('hidden');

			// Only remove negative tabindex (accessibility control for hidden elements)
			// Don't remove all tabindex, only the negative ones set for accessibility
			if (this.el.hasAttribute('tabindex')) {
				const currentTabindex = this.el.getAttribute('tabindex');
				if (currentTabindex === '-1') {
					this.el.removeAttribute('tabindex');
				}
			}

			if (this.el.hasAttribute('aria-hidden')) {
				this.el.removeAttribute('aria-hidden');
			}

			if (this.el.hasAttribute('inert')) {
				this.el.removeAttribute('inert');
			}

			// If this is the menu panel and it was initially closed,
			// make all focusable elements inside non-tabbable
			if (
				shouldMakeNonTabbable &&
				(this.el.id === 'menu-mobile' ||
					this.el.classList.contains('js-nav-panel'))
			) {
				this.makeElementsNonTabbable();
			}
		}
	}

	makeElementsNonTabbable() {
		const focusableElements = this.el.querySelectorAll(
			'summary, a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])',
		);
		for (const el of focusableElements) {
			// Only add tabindex="-1" if the element doesn't already have a specific tabindex
			if (!el.hasAttribute('tabindex') || el.getAttribute('tabindex') === '0') {
				el.setAttribute('tabindex', '-1');
				el.dataset.tempTabindex = 'true'; // Mark elements we modified
			}
		}
	}
}
